/**
 * Created by mykurisu on 2017/8/2.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import {SearchBar} from 'react-weui'

class ListenerManageSearch extends React.Component {


    handleChange(text) {
        this.props.dispatch({
            type: 'LISTENER_SEARCH',
            payload: text
        })
    }

    hendleSearch() {
        const {listenermanage} = this.props;
        this.context.page.showToast('搜索中', 'loading');
        axios.get(`/api/${listenermanage.url_data.type}/${listenermanage.url_data.id}/listener_list`, {
            params: {
                granted: 'passed',
                keyword: listenermanage.searchKeys
            }
        }).then((res) => {
            if (res.data.code === 0){
                let list = res.data.data.listeners;
                for (let i = 0;i<res.data.data.listeners.length;i++){
                    list[i].checked = false;
                    list[i].type = 'passed'
                }
                console.log(list);
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_PASSED_INIT',
                    payload: res.data.data
                });
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_PASSED_APPEND',
                    payload: list
                })
            }
        });


        axios.get(`/api/${listenermanage.url_data.type}/${listenermanage.url_data.id}/listener_list`, {
            params: {
                granted: 'rejected',
                keyword: listenermanage.searchKeys
            }
        }).then((res) => {
            if (res.data.code === 0){
                let list = res.data.data.listeners;
                for (let i = 0;i<res.data.data.listeners.length;i++){
                    list[i].checked = false;
                    list[i].type = 'rejected'
                }
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_REJECTED_INIT',
                    payload: res.data.data
                });
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_REJECTED_APPEND',
                    payload: list
                })
            }
        })
    }

    handleCancel() {
        const {listenermanage} = this.props;
        axios.get(`/api/${listenermanage.url_data.type}/${listenermanage.url_data.id}/listener_list`, {
            params: {
                granted: 'passed',
                keyword: ''
            }
        }).then((res) => {
            if (res.data.code === 0){
                for (let i = 0;i<res.data.data.listeners.length;i++){
                    res.data.data.listeners[i].checked = false;
                    res.data.data.listeners[i].type = 'passed'
                }
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_PASSED_INIT',
                    payload: res.data.data
                });
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_PASSED_APPEND',
                    payload: res.data.data.listeners
                })
            }
        });


        axios.get(`/api/${listenermanage.url_data.type}/${listenermanage.url_data.id}/listener_list`, {
            params: {
                granted: 'rejected',
                keyword: ''
            }
        }).then((res) => {
            if (res.data.code === 0){
                for (let i = 0;i<res.data.data.listeners.length;i++){
                    res.data.data.listeners[i].checked = false;
                    res.data.data.listeners[i].type = 'rejected'
                }
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_REJECTED_INIT',
                    payload: res.data.data
                });
                this.props.dispatch({
                    type: 'LISTENER_MANAGE_REJECTED_APPEND',
                    payload: res.data.data.listeners
                })
            }
        })
    }


    render() {
        return (
            <div className="listener-manage-searchbar">
                <SearchBar
                    onChange={this.handleChange.bind(this)}
                    onSubmit={this.hendleSearch.bind(this)}
                    onCancel={this.handleCancel.bind(this)}
                    onClear={this.handleCancel.bind(this)}
                    defaultValue={this.props.listenermanage.searchKeys}
                    placeholder="搜索"
                    lang={{
                        cancel: '取消'
                    }}/>
            </div>
        )
    }
}

ListenerManageSearch.contextTypes = {
    page: React.PropTypes.object,
};

export default connect(state => ({
    listenermanage: state.listenermanage
}))(ListenerManageSearch)


// WEBPACK FOOTER //
// ./src/components/listenerManage/ListenerManageSearch.js